<div class="elevator-displayNote-page">
  <div class="widgets-container">
    <div class="widgets-grid">
      @if (user.internalAccess) {
        <div class="cell-notes">
          <app-infoportal-notes-facility-overview
            [facilityNoInternal]="data?.anlageNrIntern"
            (noteFacilityCreated)="onFacilityNotesChanged()"
            (noteFacilityUpdated)="onFacilityNotesChanged()"
            (noteFacilityDeleted)="onFacilityNotesChanged()"
            [showPagination]="true"
            >
          </app-infoportal-notes-facility-overview>
        </div>
      }
    </div>
  </div>
</div>